import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router/routes'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import Paginate from "vuejs-paginate-next";
import storeConfigs from './store/store'
import { quillEditor } from "vue3-quill";
import Notifications from "vue3-vt-notifications";
import "tailwindcss/dist/tailwind.css";
import DisableAutocomplete from 'vue-disable-autocomplete';
import print from 'vue3-print-nb'
import Particles from "particles.vue3";
import '../node_modules/nprogress/nprogress.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'floating-vue/dist/style.css'
import Vue3SocialSharingPlugin from 'vue3-social-sharing';
import { createHead } from '@vueuse/head';
const head = createHead();

import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'

import useEventBus from '@/composables/useEventBus'
const { emitEvent, onEvent } = useEventBus();

// Normalize responses globally to avoid format inconsistencies (prod vs dev)
axios.interceptors.response.use(
    (response) => {
        const resp = response && response.data ? response.data : response;
        // normalize messages
        if (!resp.messages && resp.message) {
            resp.messages = Array.isArray(resp.message) ? resp.message : [resp.message];
        }
        if (resp.messages && typeof resp.messages === 'string') resp.messages = [resp.messages];
        if (!resp.messages) resp.messages = [];
        // normalize data
        if (typeof resp.data === 'undefined') {
            const resourceKeys = ['id', 'access_token', 'token_type', 'user_name', 'email', 'name'];
            const hasResourceKey = resp && typeof resp === 'object' && Object.keys(resp).some(k => resourceKeys.includes(k));
            if (hasResourceKey) {
                response.data = { data: resp, messages: resp.messages };
            } else {
                response.data = { data: resp.data ?? null, messages: resp.messages };
            }
        } else {
            response.data = resp;
        }
        return response;
    },
    (error) => {
        // try to normalize error response as well
        if (error && error.response && error.response.data) {
            const resp = error.response.data;
            if (!resp.messages && resp.message) resp.messages = Array.isArray(resp.message) ? resp.message : [resp.message];
            if (resp.messages && typeof resp.messages === 'string') resp.messages = [resp.messages];
            error.response.data = resp;
        }
        return Promise.reject(error);
    }
);

import { 
    generateFirestoreId, highlightMention, extractFileName, formatDate, formatDate2, 
    getYouTubeEmbedUrl, extractIdFromSlug, removeStringFromFileLink, formatNumber, formatDateTime,
    truncatedTitle, setDocumentTitle, gotoHomePersonal, getUserLogin, formatTime
} from './helper'

const app = createApp(App);
app.use(router);
app.use(VueAxios, axios)
app.use(storeConfigs)
app.use(Paginate)
app.use(quillEditor)
app.use(Notifications)
app.use(DisableAutocomplete)
app.use(print)
app.use(Particles)
app.use(VueDatePicker)
app.use(VueTippy)
app.use(VueSweetalert2)
app.use(Vue3SocialSharingPlugin);
app.use(head);
app.use(Vue3VideoPlayer, {
    lang: 'en'
})
app.config.globalProperties.$emitEvent = emitEvent
app.config.globalProperties.$onEvent = onEvent
app.config.globalProperties.$formatDate = formatDate
app.config.globalProperties.$formatDate2 = formatDate2
app.config.globalProperties.$getYouTubeEmbedUrl = getYouTubeEmbedUrl
app.config.globalProperties.$extractIdFromSlug = extractIdFromSlug
app.config.globalProperties.$removeStringFromFileLink = removeStringFromFileLink
app.config.globalProperties.$formatNumber = formatNumber
app.config.globalProperties.$extractFileName = extractFileName
app.config.globalProperties.$highlightMention = highlightMention
app.config.globalProperties.$generateFirestoreId = generateFirestoreId
app.config.globalProperties.$formatDateTime = formatDateTime
app.config.globalProperties.$truncatedTitle = truncatedTitle
app.config.globalProperties.$setDocumentTitle = setDocumentTitle
app.config.globalProperties.$gotoHomePersonal = gotoHomePersonal
app.config.globalProperties.$getUserLogin = getUserLogin
app.config.globalProperties.$formatTime = formatTime
app.mount('#app')
